export class TurnoUACModel {

    public idTurno: string;
    public numeroTurno: string;
    public fechaCreacion: string;
    public tipoDocVisitante: string;
    public numDocVisitante: string;
    public idTramite: string;
    public estado: string;
    public fechaInicialAtencion: string;
    public fechaFinalAtencion: string;
    public tipoIdFuncionario: string;
    public numIdFuncionario: string;
    public fechaTurno: string;
    public ordenPrioridad: string;
    public numeroVentanilla: string;
    public sede: string;
    public motivoPrioridad: string;
    public tipoDiscapacidad: string;
    public idAgendaVirtual?: number;
    public nombreTramite?: string;
    public nombreVisitante?: string;
    public telefonoVisitante?: string;
    public requiereCertificado?: boolean;
    public generoVisitante?: string;
    public correoVisitante?: string;
    public observaciones?: string;
    public letraTurno?: string;
    public tienePrioridad?: boolean;
    public numeroIdFuncionario?: string;
    public nombreCompleto?: string;
}